import { BOORSOK_FONT } from "@util/constants";
import React from "react";
import styled from "styled-components";
import { Maybe } from "@graphql-types";
// @ts-ignore
import marqueeImage from "@static/assets/snackles/marquee-img.png";
// @ts-ignore
import marqueeImage1 from "@static/assets/snackles/marquee-img1.png";

// @ts-ignore
import {mainData} from '../locales/dataConst';
interface Props {
  pageIban : Maybe<string> | undefined;
}
const SnacklesMarquee = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  transition: all 0.7s ease;
  z-index: 9;
    &.animated {
      padding-bottom: 0;
    }
  .scrolling-banner-wrapper {
    font-size: 62px;
    line-height: 2.02;
    font-family: ${BOORSOK_FONT};
    color: #EC008C;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 7.5px;
    overflow: hidden;
    flex-shrink: 0;
    white-space: nowrap;
    animation: bannermove 20s linear infinite;
    gap: 25px;
    background: #E9EAEB;
    @keyframes bannermove {
      0% {
        transform: translate3d(0%, 0, 0);
      }
      100% {
        transform: translate3d(-100%, 0, 0);
      }
    }
  }
`;
export default function Marquee({pageIban}: Props) {
 
  const marquee = mainData[pageIban]

  return (
    <>
      <SnacklesMarquee id="snackles-carousel">
        <div className="scrolling-banner-wrapper">
          <img src={marqueeImage} alt="snackles-chocolate" />
          {marquee.marqueeText}
          <img src={marqueeImage1} alt="snackles-chocolate" />
          {marquee.marqueeText}
          <img src={marqueeImage} alt="snackles-chocolate" />
          {marquee.marqueeText}
        </div>
        <div className="scrolling-banner-wrapper">
          <img src={marqueeImage1} alt="snackles-chocolate" />
          {marquee.marqueeText}
          <img src={marqueeImage} alt="snackles-chocolate" />
          {marquee.marqueeText}
          <img src={marqueeImage1} alt="snackles-chocolate" />
          {marquee.marqueeText}
        </div>
      </SnacklesMarquee >
      <div className="marquee-bottom-line"></div>
    </>

  );
}
